// Apresentação da tela "Imagens": tamanho, linhas da tabela e resumo. Sem React
// aqui, para testar.

export type ImageTag = {
  tag: string;
  commit?: string;
  digest?: string;
  sizeBytes?: number;
  createdAt?: string;
  usedBy: string[];
};

export type ImageRepository = {
  name: string;
  cache: boolean;
  // Nome da aplicação do pipeline que usa este repositório (permite "Usar esta versão").
  app?: string;
  tagCount: number;
  tags: ImageTag[];
};

export type ImageRow = ImageTag & { repository: string; cache: boolean; app?: string };

const NUMBER = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });

export function formatBytes(bytes: number | undefined): string {
  if (bytes === undefined) return '-';
  const mib = bytes / (1024 * 1024);
  return mib >= 1024 ? `${NUMBER.format(mib / 1024)} GiB` : `${NUMBER.format(mib)} MiB`;
}

// Uma linha por tag, mais recente primeiro dentro de cada repositório. O cache de
// build (Kaniko) só entra quando pedido: não é imagem de aplicação.
export function toRows(repositories: ImageRepository[], showCache: boolean): ImageRow[] {
  return repositories
    .filter(repository => showCache || !repository.cache)
    .flatMap(repository =>
      repository.tags.map(tag => ({ ...tag, repository: repository.name, cache: repository.cache, app: repository.app })),
    );
}

export function summary(rows: ImageRow[]): string {
  const repositories = new Set(rows.map(row => row.repository)).size;
  const total = rows.reduce((sum, row) => sum + (row.sizeBytes ?? 0), 0);
  return `${rows.length} ${rows.length === 1 ? 'imagem' : 'imagens'} em ${repositories} ${repositories === 1 ? 'repositório' : 'repositórios'}, ${formatBytes(total)} no total`;
}

// "Usar esta versão" só para tag de uma aplicação do pipeline que não é a que está
// rodando agora e que ainda tem as informações lidas do registry.
export function canUseVersion(row: ImageRow): boolean {
  return !row.cache && !!row.app && row.usedBy.length === 0 && !!row.digest;
}
